// extracted by mini-css-extract-plugin
export var alignDiscLeft = "v_rY d_fp d_bG d_dv";
export var alignLeft = "v_qh d_fp d_bG d_dv";
export var alignDiscCenter = "v_rZ d_fq d_bD d_dw";
export var alignCenter = "v_bP d_fq d_bD d_dw";
export var alignDiscRight = "v_r0 d_fr d_bH d_dx";
export var alignRight = "v_qj d_fr d_bH d_dx";
export var footerContainer = "v_r1 d_dW d_bW";
export var footerContainerFull = "v_r2 d_dT d_bW";
export var footerHeader = "v_kf d_kf";
export var footerTextWrapper = "v_r3 d_w";
export var footerDisclaimerWrapper = "v_km d_km d_ck";
export var badgeWrapper = "v_r4 d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "v_r5 d_bz d_bJ d_bN d_bL";
export var wide = "v_r6 d_cy";
export var right = "v_r7 d_bK";
export var line = "v_fk d_fl d_cv";
export var badgeDisclaimer = "v_r8 d_bC d_bP d_bJ";
export var badgeContainer = "v_r9 d_bz d_bH d_bP";
export var badge = "v_sb";
export var padding = "v_sc d_c7";
export var end = "v_sd d_bH";
export var linkWrapper = "v_sf d_dB";
export var link = "v_mC d_dB";
export var colWrapper = "v_sg d_cx";
export var consent = "v_f d_f d_bC d_bP";
export var disclaimer = "v_sh d_bz d_bJ";
export var media = "v_sj d_bx d_dy";
export var itemRight = "v_sk";
export var itemLeft = "v_sl";
export var itemCenter = "v_sm";
export var exceptionWeight = "v_sn G_vw";